<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {
    if (!this.$store.state.token) {
      this.$router.replace('/login')
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped></style>
